const firebase = require('./firebase')
const url = require('./url')
const cloudFunction = require('./cloudFunction')

module.exports = {
  firebase,
  url,
  cloudFunction
}



// WEBPACK FOOTER //
// ./src/config/index.js